import { render, staticRenderFns } from "./base-table-cell.vue?vue&type=template&id=f7da89ba"
import script from "./base-table-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./base-table-cell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-table-cell.vue?vue&type=style&index=0&id=f7da89ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports